<template>
<div class="container">
    <h2>你的外网IP地址：</h2>
    <h2><span id="ipaddr">{{ client.wanip }}</span></h2>
    <br>
    <br>
    <p>
        <a id="btn_copy_addr" class="btn btn-primary btn-lg" role="button" 
            data-clipboard-target="#ipaddr" @click="copyToClip">复制地址</a>
    </p>
</div>
</template>

<script>
import clipboard from 'clipboard'

export default {
    name:"IPBoard",
    data:function(){
        return {
            client:{
                wanip:'0.0.0.0'
            }
        }
    },
    created:function(){
        this.getWanIP()
    },
    methods:{
        copyToClip:function(){
            let clip = new clipboard('#btn_copy_addr')
            clip.on('success',e=>{
                alert('复制成功')
                clip.destroy()
            })
            clip.on('error', e=>{
                alert('复制失败')
                clip.destroy()
            })
        },
        getWanIP:function(){
            this.axios.get('./api/get_wan_ip.php').then(response=>{
                this.client.wanip = response.data.data.ip
            })
        }
    }
}
</script>

<style scoped>

</style>
